// extracted by mini-css-extract-plugin
module.exports = {"centerWrap":"Home_centerWrap__2Fxvi"};